module.exports = __webpack_public_path__ + "static/header-shape-a982107df28610fb9e50f026c0a89e24.png";